/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetails_viewer = {
    readonly isMessageCenterEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"ContactDealerInlineForm_viewer" | "PdpSharedSellerTabsVariant_viewer" | "PdpRespSimilarItemTileCarousel_viewer">;
    readonly " $refType": "PdpRespDealerDetails_viewer";
};
export type PdpRespDealerDetails_viewer$data = PdpRespDealerDetails_viewer;
export type PdpRespDealerDetails_viewer$key = {
    readonly " $data"?: PdpRespDealerDetails_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerDetails_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespDealerDetails_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isMessageCenterEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "MESSAGE_CENTER"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "ContactDealerInlineForm_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerTabsVariant_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemTileCarousel_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'bb06638c1af356f57ba468bd91f21db7';
export default node;
